import { render, staticRenderFns } from "./AddStudySet.vue?vue&type=template&id=8e9b1bdc&scoped=true&"
import script from "./AddStudySet.vue?vue&type=script&lang=js&"
export * from "./AddStudySet.vue?vue&type=script&lang=js&"
import style0 from "./AddStudySet.vue?vue&type=style&index=0&id=8e9b1bdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9b1bdc",
  null
  
)

export default component.exports